import Header from 'components/headers/bulletins'
import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import posthog from 'posthog-js'
import SubHeader from './subheader'
import useGetLoans from './hooks/useGetLoans'
import Loans from './loans'
import DotsLoading from 'components/loadings/dotsLoading'
import PayToOtherModal from 'components/modals/payToOther'
import useGetMoneyPoolManagement from '../fundPage/hooks/useGetMoneyPoolManagement'
import useSetUser from './hooks/useSetUser'
import useGetSubHeaderLoans from './hooks/useGetSubHeaderLoans'
import CustomBottomSheet from 'components/bottomSheet'
import LoanGuarantors from './LoanGuarantors'
import { toast } from 'react-toastify'

export default function UserFundsDetail() {
    const [isOpenLink, setIsOpenLink] = useState<boolean>(false)
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [loanAmount, setLoanAmount] = useState<number | undefined>()
    const { moneyPool, loanId } = useParams()
    const { state } = useLocation()
    const { data, isLoading } = useGetLoans()
    useEffect(() => {
        posthog.capture('loan_detail_viewed', {
            fund_id: moneyPool,
            loan_id: loanId,
        })
    }, [moneyPool, loanId])
    const { moneyPoolManagement } = useGetMoneyPoolManagement(moneyPool)
    const { selectUser } = useSetUser(data?.results.installments[0].poolship)
    const { subHeaderData } = useGetSubHeaderLoans(
        data?.results.installments[0].loan
    )
    const [selectedInstallment, setSelectedInstallment] = useState<
        number | undefined
    >()
    return (
        <div className="bg-white min-h-screen pb-6">
            <Header title={`وام ${state.name}`} />
            {subHeaderData ? (
                <>
                    <SubHeader
                        data={subHeaderData}
                        setIsOpenLink={setIsOpenLink}
                    />
                    <LoanGuarantors
                        moneypoolId={moneyPool}
                        loanId={loanId}
                        borrowerPoolshipId={
                            data?.results.installments[0].poolship
                        }
                        isManager={
                            moneyPoolManagement?.poolship?.role === 'mgr' ||
                            moneyPoolManagement?.poolship?.role === 'own'
                        }
                    />
                </>
            ) : (
                <DotsLoading />
            )}
            {data && !isLoading ? (
                <Loans
                    data={data.results.installments}
                    setIsOpen={setIsOpen}
                    setLoanAmount={setLoanAmount}
                    setSelectedInstallment={setSelectedInstallment}
                />
            ) : (
                <DotsLoading />
            )}
            <PayToOtherModal
                show={isOpen}
                onHide={() => setIsOpen(false)}
                isManager={false}
                name={moneyPoolManagement && moneyPoolManagement.name}
                item={selectUser}
                loanAmount={loanAmount}
                moneyPool={moneyPool}
                isLoan
                selectedInstallment={selectedInstallment}
                trustState={moneyPoolManagement?.trust_state}
            />
            {subHeaderData && (
                <CustomBottomSheet
                    isOpen={isOpenLink}
                    onDismiss={() => setIsOpenLink(false)}
                >
                    <div>
                        <p className="text-center font-bold text-black mb-3">
                            اشتراک گذاری لینک پرداخت حق عضویت
                        </p>
                        <hr />
                        <div className=" my-4 px-3">
                            <p
                                className="text-center text-lg my-2 py-2 text-text-body active:scale-[0.98] transition-transform cursor-pointer"
                                onClick={() => {
                                    navigator.clipboard.writeText(
                                        subHeaderData?.short_url
                                    )
                                    toast.success('لینک با موفقیت کپی شد')
                                    setIsOpenLink(false)
                                }}
                            >
                                کپی لینک
                            </p>
                            <p
                                className="text-center text-lg my-2 py-2 text-text-body active:scale-[0.98] transition-transform cursor-pointer"
                                onClick={() => {
                                    navigator.share({
                                        url: subHeaderData.short_url,
                                        title: 'پرداخت قسط وام',
                                    })
                                    setIsOpenLink(false)
                                }}
                            >
                                سایر اپلیکیشن ها
                            </p>
                        </div>
                    </div>
                </CustomBottomSheet>
            )}
        </div>
    )
}
